import {
	API_GET_CITIES_POSTALCODE,
	API_GET_CITIES_POSTALCODE_SUCCESS,
	API_GET_CITIES_POSTALCODE_FAIL,
	RESET_LIST,
	RESET_WORK_LIST,
} from "../actions/city";
import { createReducer } from "@reduxjs/toolkit";
import { errorHandler, ErrorAction } from "utils/error";

const initialState = {
	loading: false,
	list: [],
	workList: [],
};

const cities = createReducer(initialState, {
	/** GET_CITIES_POSTALCODE **/
	[API_GET_CITIES_POSTALCODE]: (state, action) => {
		state.loading = true;
	},
	[API_GET_CITIES_POSTALCODE_FAIL]: (state, action) => {
		errorHandler("Ville", ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_CITIES_POSTALCODE_SUCCESS]: (state, action) => {
		state.loading = false;
		if (action.meta.previousAction.work) state.workList = action.payload.data;
		else state.list = action.payload.data;
	},
	[RESET_LIST]: (state, action) => {
		state.loading = false;
		state.list = [];
	},
	[RESET_WORK_LIST]: (state, action) => {
		state.loading = false;
		state.workList = [];
	},
});

export default cities;
